import { IRule } from "../../types";
import { RuleConstraint } from "./types";

export const getDefaultConstraints = (data: IRule | undefined) => {
    const result = [];
    if (data?.pickupDateTimeFrom) {
        result.push(RuleConstraint.PickupDateTimeFrom);
    }
    if (data?.pickupDateTimeTo) {
        result.push(RuleConstraint.PickupDateTimeTo);
    }
    if (data?.dropoffDateTimeFrom) {
        result.push(RuleConstraint.DropoffDateTimeFrom);
    }
    if (data?.dropoffDateTimeTo) {
        result.push(RuleConstraint.DropoffDateTimeTo);
    }
    if (data?.includingDateTimeFrom) {
        result.push(RuleConstraint.IncludingDateTimeFrom);
    }
    if (data?.includingDateTimeTo) {
        result.push(RuleConstraint.IncludingDateTimeTo);
    }
    if (data?.pickupLocations && data.pickupLocations.length > 0) {
        result.push(RuleConstraint.PickupLocations);
    }
    if (data?.dropoffLocations && data.dropoffLocations.length > 0) {
        result.push(RuleConstraint.DropoffLocations);
    }
    if (data?.pickupAreas && data.pickupAreas.length > 0) {
        result.push(RuleConstraint.PickupAreas);
    }
    if (data?.dropoffAreas && data.dropoffAreas.length > 0) {
        result.push(RuleConstraint.DropoffAreas);
    }
    if (data?.pickupRegions && data.pickupRegions.length > 0) {
        result.push(RuleConstraint.PickupRegions);
    }
    if (data?.dropoffRegions && data.dropoffRegions.length > 0) {
        result.push(RuleConstraint.DropoffRegions);
    }
    if (data?.pickupZones && data.pickupZones.length > 0) {
        result.push(RuleConstraint.PickupZones);
    }
    if (data?.dropoffZones && data.dropoffZones.length > 0) {
        result.push(RuleConstraint.DropoffZones);
    }
    if (data?.acrissList && data.acrissList.length > 0) {
        result.push(RuleConstraint.AcrissList);
    }
    if (data?.sippList && data.sippList.length > 0) {
        result.push(RuleConstraint.SippList);
    }
    if (data?.customerCodes && data.customerCodes.length > 0) {
        result.push(RuleConstraint.CustomerCodes);
    }
    if (data?.salesChannels && data.salesChannels.length > 0) {
        result.push(RuleConstraint.SalesChannels);
    }
    if (data?.segments && data.segments.length > 0) {
        result.push(RuleConstraint.Segments);
    }
    if (data?.categories && data.categories.length > 0) {
        result.push(RuleConstraint.Categories);
    }
    if (data?.products && data.products.length > 0) {
        result.push(RuleConstraint.Products);
    }
    if (data?.rates && data.rates.length > 0) {
        result.push(RuleConstraint.Rates);
    }
    if (data?.ancillaries && data.ancillaries.length > 0) {
        result.push(RuleConstraint.Ancillaries);
    }
    if (data?.minDuration) {
        result.push(RuleConstraint.MinDuration);
    }
    if (data?.maxDuration) {
        result.push(RuleConstraint.MaxDuration);
    }
    if (data?.minNoticeDays) {
        result.push(RuleConstraint.MinNoticeDays);
    }
    if (data?.maxNoticeHours) {
        result.push(RuleConstraint.MaxNoticeHours);
    }
    return result;
}